<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
import axios from 'axios';

export default {
    components: {
        Editor,
    },
    props: {
        field: {
            type: Object,
            default: () => {},
        },
        value: {
            type: [String, Number, Boolean, Array, Object],
            default: null,
        },
    },
    data() {
        return {
            editorConfig: {
                hideModeSwitch: false,
                usageStatistics: false,
                hooks: {
                    addImageBlobHook: (blob, callback) => {
                        const formData = new FormData();
                        formData.append('file', blob);

                        axios.post('/api/media', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }).then((response) => {
                            callback(response.data.url, '');
                        });
                    },
                    changeMode: (mode) => {
                        localStorage.setItem('editorMode', mode);
                    },
                },
            },
        };
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(field) {
                this.$emit('input', field);
            },
        },
    },
    mounted() {
        if (localStorage.getItem('editorMode')) {
            this.$refs.toastuiEditor.invoke('changeMode', localStorage.getItem('editorMode'));
        }

        if (this.fieldValue) {
            this.$refs.toastuiEditor.invoke('setMarkdown', this.fieldValue);
        }
    },
    methods: {
        onEditorChange() {
            this.fieldValue = this.$refs.toastuiEditor.invoke('getMarkdown');
        },
    },
};
</script>

<template>
    <Editor
        ref="toastuiEditor"
        :options="editorConfig"
        initial-edit-type="wysiwyg"
        preview-style="tab"
        @change="onEditorChange"
    />
</template>

<style
    scoped
    lang="scss"
>

</style>
